import { gql } from "@apollo/client";

export const SEARCH_UNIFIED_USERS = gql`
  query searchUnifiedUsers($searchTerm: String!) {
    searchUnifiedUsers(searchTerm: $searchTerm) {
      id
      nombre
      apellido
      dni
      email
      username
      tipoUser
      appUsuario
      tipoApp
      token
      vencimiento
    }
  }
`;

export const selectUsersBySource = (users = [], source) =>
  users.filter((user) => {
    const userSource = user?.appUsuario || user?.tipoApp;
    return !source || userSource === source;
  });
